import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStoreManager } from './local-store-manager.service';
import { SalPeriodGroup } from '../models/salprdgrp.model';

@Injectable()
export class SalPeriodGroupService {
  private salprdgroupUrl: string = 'api/salprdgrps';

  constructor(
    private http: HttpClient,
    private localStorage: LocalStoreManager) { }

  getsalprdgroups(): Observable<SalPeriodGroup[]> {
    let sitename = this.localStorage.getDataObject("sitename");
    let endpointUrl = `${this.salprdgroupUrl}/${sitename}`;
    return this.http.get<SalPeriodGroup[]>(endpointUrl);
  }

}

